import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export const CustomToast = ({ type, title, message }) => {
  return (
    <div className={`toast-holder-main-custom toast-${type}`}>
      <div className="toast-holder-icon-title">
        <div className="toast-icon">
          {type === "success" && <CheckIcon />}
          {type === "error" && <CloseIcon />}
          {type === "info" && "ℹ️"}
        </div>
        <div className="toast-title">{title}</div>
      </div>
      <div className="toast-content">
        <div className="toast-text">{message}</div>
      </div>
    </div>
  );
};
